import React, {useState} from "react";
import {
    Datagrid,
    DateField,
    Filter,
    List,
    SimpleShowLayout,
    TextField,
    TextInput,
    required,
    BooleanField,
    BooleanInput,
    NumberInput,
    NumberField,
    ArrayField,
    ArrayInput,
    SimpleFormIterator, SelectInput
} from "react-admin";
import CreateView from "../../components/CreateView";
import ShowView from "../../components/ShowView";
import Emoji from "../../components/Emoji";
import {PersianDateExpirationDatePicker} from "../../components/PersianDatePickers";
import {DiscountTypes} from "../discount/diacountConstants";

export const BulkDiscountList = (props) => (
  <List {...props}>
    <Datagrid rowClick="show">
        <TextField source="objectId"/>
        <NumberField source="percent"/>
        <NumberField source="count"/>
        <NumberField source="consumed"/>
        <BooleanField source="isDeleted"/>
        <DateField showTime={true} locales={"fa-IR"} source="createdAt"/>
        <DateField showTime={true} locales={"fa-IR"} source="updatedAt"/>
    </Datagrid>
  </List>
);

export const BulkDiscountCreate = (props) => {
    const [expirationDate, setExpirationDate] = useState(new Date().setHours(0,0));
    function expirationDateChange(e){
        setExpirationDate(e._d.setHours(0,0))
    }
    return (
        <CreateView {...props} perPage={10}>
            <NumberInput source="percent" validate={required()}/>
            <NumberInput source="count" validate={required()}/>
            <NumberInput source="limit" validate={required()}/>
            <Emoji source="description" label="توضیحات"/>
            <SelectInput source="type" validate={required()} choices={DiscountTypes}/>
            <TextInput source="prefix" validate={required()}/>
            <BooleanInput source="isDeleted" defaultValue={false}/>
            <PersianDateExpirationDatePicker
                name="expirationDate"
                value={expirationDate}
                onChange={expirationDateChange}
                label={"تاریخ انقضا"}
            />
            <ArrayInput source="adminPlansId">
                <SimpleFormIterator>
                    <TextInput source="plansId"/>
                </SimpleFormIterator>
            </ArrayInput>

            <ArrayInput source="adminSpecialistIds">
                <SimpleFormIterator>
                    <TextInput source="specialistIds"/>
                </SimpleFormIterator>
            </ArrayInput>

            <ArrayInput source="adminClinicCategories">
                <SimpleFormIterator>
                    <TextInput source="clinicCategories"/>
                </SimpleFormIterator>
            </ArrayInput>

            <ArrayInput source="adminSpecialistCardIds">
                <SimpleFormIterator>
                    <TextInput source="specialistCardIds"/>
                </SimpleFormIterator>
            </ArrayInput>
        </CreateView>
    )
}


export const BulkDiscountShow = (props) => (
  <ShowView {...props} noEdit={true}>
    <SimpleShowLayout>
        <TextField source="objectId"/>
        <NumberField source="percent"/>
        <NumberField source="count"/>
        <NumberField source="limit"/>
        <TextField source="description"/>
        <TextField source="prefix"/>
        <NumberField source="consumed"/>
        <TextField source="typeName"/>
        <DateField showTime={true} locales={"fa-IR"} source="expirationDate"/>
        <ArrayField source="adminPlansId">
            <Datagrid>
                <TextField source="plansId" />
            </Datagrid>
        </ArrayField>
        <ArrayField source="adminSpecialistIds">
            <Datagrid>
                <TextField source="specialistIds" />
            </Datagrid>
        </ArrayField>
        <ArrayField source="adminClinicCategories">
            <Datagrid>
                <TextField source="clinicCategories" />
            </Datagrid>
        </ArrayField>
        <ArrayField source="adminSpecialistCardIds">
            <Datagrid>
                <TextField source="specialistCardIds" />
            </Datagrid>
        </ArrayField>
        <BooleanField source="isDeleted"/>
        <DateField showTime={true} locales={"fa-IR"} source="createdAt"/>
        <DateField showTime={true} locales={"fa-IR"} source="updatedAt"/>
    </SimpleShowLayout>
  </ShowView>
);
